import * as React from 'react';

import classNames from 'classnames';

import {CardWidgetEmptyState} from 'shells/empty-states/card-widget-empty-state';
// @ts-expect-error
import {TickCircleIcon} from 'shells/icon/svg/tick-circle-icon';
import {SectionLabel} from 'shells/typography/section-label';

import styles from './pipeline-tasks.module.css';

type Props = {
    pipelineTasks: HTMLElement;
    onRenderLeadMarkup: () => void;
    numTasks: number;
};

export function PipelineTasks(props: Props) {
    const {onRenderLeadMarkup, numTasks} = props;

    const [didRender, setDidRender] = React.useState<boolean>(false);

    const handleRef = React.useCallback(
        (ref?: HTMLElement | null) => {
            if (ref && onRenderLeadMarkup && !didRender) {
                onRenderLeadMarkup();
                setDidRender(true);
            }
        },
        [onRenderLeadMarkup, didRender]
    );

    // We don't want to hide the server markup for the old sales process because
    // it has functionality we need to persist
    const hasContent = numTasks > 0 || !NutClientConfig.hasSalesProcessSetupOverhaulNUT7581;
    // Even when we show the old sales process markup, we want to show the empty
    // state if there are no tasks
    const shouldRenderEmptyStateOverride =
        numTasks === 0 && !NutClientConfig.hasSalesProcessSetupOverhaulNUT7581;

    React.useEffect(() => {
        Nut.updateAppearances();
    }, [numTasks, didRender]);

    return (
        <div className='flex flex-dir-col'>
            <div
                className={classNames({
                    [styles['pipeline-tasks-header--content']]: hasContent,
                })}
            >
                <SectionLabel noBottomMargin={hasContent} noBottomBorder={hasContent}>
                    Stage tasks
                </SectionLabel>
            </div>
            <div
                className={classNames({
                    [styles['jQuery-compatible-hidden']]: !hasContent,
                })}
            >
                <div
                    dangerouslySetInnerHTML={{
                        __html: props.pipelineTasks.outerHTML,
                    }}
                    ref={handleRef}
                />
            </div>
            {(!hasContent || shouldRenderEmptyStateOverride) && (
                <div className='my-16'>
                    <CardWidgetEmptyState
                        icon={TickCircleIcon}
                        text='No tasks have been set for this lead’s stage'
                        isHorizontal={true}
                    />
                </div>
            )}
        </div>
    );
}
